import { jsx as c } from "react/jsx-runtime";
import { clsx as l } from "../../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.js";
import { remCalc as E } from "../../style/base/index.js";
import { RocheUIButtonType as U } from "../button/roche-button-types.js";
import { RocheUIIcon as f } from "../icon/roche-icon.js";
import o from "./roche-icon-button.module.scss.js";
import { RocheUIIconButtonAppearance as t, RocheUIIconButtonSize as i } from "./roche-icon-button.types.js";
const h = 24, D = ({
  icon: m,
  ariaLabel: s,
  appearance: n = t.DEFAULT,
  size: u = i.DEFAULT,
  type: e = U.BUTTON,
  disabled: r = !1,
  onClick: R,
  ...I
}) => {
  const b = l(
    o["icon-button"],
    r && o["icon-button--disabled"],
    u === i.LARGE && o["icon-button--size-large"],
    n === t.DEFAULT && o["icon-button--default"],
    n === t.PRIMARY && o["icon-button--primary"],
    n === t.SECONDARY && o["icon-button--secondary"],
    n === t.TERTIARY && o["icon-button--tertiary"],
    n === t.SUCCESS && o["icon-button--success"],
    n === t.ERROR && o["icon-button--error"]
  );
  return /* @__PURE__ */ c(
    "button",
    {
      className: b,
      type: e,
      disabled: r,
      onClick: R,
      "aria-label": s,
      ...I,
      children: /* @__PURE__ */ c(f, { icon: m, height: `${E(h)}rem` })
    }
  );
};
export {
  D as RocheUIIconButton
};
